
    /**
     * @description
     *  Modelo del tipo de día no-laborable. Actualmente no existe un DTO
	 *	asociado en el backend ya que este campo se almacena en la base de
	 *	datos como 'string'.
     */

export enum HolidayType {

    Holiday = "no-laboral"
}

export const toHolidayTypeString = function (holidayType: HolidayType): string {
	switch (holidayType) {
		case HolidayType.Holiday:
			return "No Laborable";
		default: {
			return "[Unknown HolidayType]";
		}
	}
};
